import { PropsWithChildren, isValidElement } from 'react'

import { ButtonWithCopy } from '@writefull/ui'
import { clsx } from '@writefull/utils'

interface AiResultProps {
  actionCode?: string
  outputConverter?: (output: string) => string
  copyDisabled?: boolean
}

export default function AiResult({
  actionCode = undefined,
  outputConverter = undefined,
  copyDisabled = false,
  children = '',
}: PropsWithChildren<AiResultProps>) {
  return (
    <div
      className='rounded-lg h-fit overflow-hidden border border-gray-200 dark:border-transparent theme-transition'
      data-action-code={actionCode}
    >
      <div
        className={clsx(
          'py-1 px-4 flex justify-end',
          'text-gray-900 bg-gray-100 dark:bg-slate-900 theme-transition',
        )}
      >
        <ButtonWithCopy
          type='button'
          className='justify-self-end not-hover:opacity-60 dark:text-white theme-transition'
          variant='link'
          textToCopy={outputConverter?.(children as string) ?? (children as string) ?? ''}
          disabled={copyDisabled}
        />
      </div>

      <div className='p-4 bg-white dark:bg-slate-700 theme-transition'>
        {isValidElement(children) ? (
          children
        ) : (
          <p className='ai-result' dangerouslySetInnerHTML={{ __html: children ?? '' }} />
        )}
      </div>
    </div>
  )
}
